"use client";

import { Typography } from "@/components/ui/typography";
import type { UseCasesCardsProps } from "./types";
import { useCasesCardsData } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { GroupedCardCarousel, InlineQuoteBanner } from "@/components/screen/global-components/cases";

const UseCasesCards = ({ className }: UseCasesCardsProps) => {
  const { title, description, cards } = useCasesCardsData;

  return (
    <section
      className={cn(
        "section overflow-hidden bg-background-secondary lg:bg-white",
        className
      )}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[900] md:mx-auto md:text-center">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600 w-full max-w-[746] mx-auto">
            <Typography variant="subHeadingSm" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <GroupedCardCarousel cards={cards} className="mt-6 lg:!mt-12" />
        <InlineQuoteBanner className="mt-6 lg:mt-12"/>
      </div>
    </section>
  );
};

export default memo(UseCasesCards);
